import { useMemo, useEffect, useCallback } from 'react'
import { FormHandles } from '@unform/core'
import { useDispatch } from 'react-redux'
import { listProducts } from '../../store/product/actions'
import { addProducts } from '../../store/campaign/actions'

interface UseProductsPanelListProductsProps {
  filteredQuery?: string
  publisherId?: string
  subPublisherIds?: string
  isWhiteLabel?: boolean
  activeTab?: SearchProductBy
  campaignType?: CampaignType
  bulkProducts?: string
  isEdit?: boolean
  formRef?: React.MutableRefObject<FormHandles>
}

export function useProductsPanelListProducts({
  filteredQuery,
  publisherId,
  subPublisherIds,
  isWhiteLabel,
  activeTab,
  campaignType,
  bulkProducts,
  isEdit,
  formRef
}: UseProductsPanelListProductsProps) {
  const dispatch = useDispatch()

  const publisher_id =
    campaignType === 'off_site' ? subPublisherIds : publisherId
  const sub_publisher_ids =
    campaignType === 'off_site' ? undefined : subPublisherIds

  const handleAddProductsBulk = useCallback(() => {
    const queryKey: AddProductsBodyQueryKey = {
      search: 'query',
      product_skus: 'product_skus',
      // Backend contract: even in the product_ids UI tab, bulk payload key stays product_skus.
      product_ids: 'product_skus',
      product_gtins: 'product_gtins',
      product_additional_references: 'product_additional_references',
      product_reference_codes: 'product_reference_codes'
    }

    const body = {
      publisher_id,
      page: 0,
      products: bulkProducts,
      isEdit,
      queryKey: queryKey?.[activeTab] || 'query',
      sub_publisher_ids
    }

    dispatch(addProducts({ body }))

    formRef.current.setFieldValue('bulkProducts', '')
  }, [
    activeTab,
    bulkProducts,
    dispatch,
    formRef,
    isEdit,
    publisherId,
    subPublisherIds
  ])

  const queryStringSearchProduct = useMemo(() => {
    return {
      quantity: 1000,
      query: filteredQuery,
      publisher_id,
      sub_publisher_ids
    }
  }, [filteredQuery, publisherId, subPublisherIds])

  useEffect(() => {
    if (
      activeTab === 'search' &&
      filteredQuery &&
      (publisherId || isWhiteLabel)
    ) {
      dispatch(listProducts(queryStringSearchProduct))
    }
  }, [
    activeTab,
    dispatch,
    filteredQuery,
    publisherId,
    queryStringSearchProduct,
    isWhiteLabel
  ])

  return { handleAddProductsBulk }
}
